import { useEffect, useRef } from "react";

function useRapidClickDetector(
  ref: React.RefObject<HTMLElement | null>,
  onComplete: () => void
) {
  const clicksRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (target.closest("input, button")) {
        return;
      }

      clicksRef.current++;

      if (timerRef.current) clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        clicksRef.current = 0;
      }, 1000);

      if (clicksRef.current === 12) {
        if (timerRef.current) clearTimeout(timerRef.current);

        clicksRef.current = 0;

        onComplete();
      }
    };

    element.addEventListener("click", handleClick);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      element.removeEventListener("click", handleClick);
    };
  }, [ref, onComplete]);
}

export { useRapidClickDetector };